import importer from 'common/importer'
const { deloitReq: req } = importer('APIs', null)
/**
 * Login Callout 4 Authenticate with Heroku
 * @param {Object} param0
 * @param {String} param0.id_token
 */
const callout4 = ({ id_token }) => {
  return req.get('/users/login', {
    headers: {
      Authorization: id_token
    }
  })
}

export default callout4
